var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./api/Locale": "ea54",
	"./api/Locale.js": "ea54",
	"./api/PortfolioInternal": "589a",
	"./api/PortfolioInternal.js": "589a",
	"./api/Validation": "e647",
	"./api/Validation.js": "e647",
	"./api/blog/01": "cbb2",
	"./api/blog/01.json": "cbb2",
	"./api/blog/02": "d271",
	"./api/blog/02.json": "d271",
	"./api/blog/03": "9085",
	"./api/blog/03.json": "9085",
	"./api/blog/04": "cc1e",
	"./api/blog/04.json": "cc1e",
	"./api/blog/05": "9da0",
	"./api/blog/05.json": "9da0",
	"./api/blog/06": "30a1",
	"./api/blog/06.json": "30a1",
	"./api/blog/07": "ffa1",
	"./api/blog/07.json": "ffa1",
	"./api/blog/08": "2386",
	"./api/blog/08.json": "2386",
	"./api/blog/09": "8805",
	"./api/blog/09.json": "8805",
	"./api/blog/default": "4ff0",
	"./api/blog/default.json": "4ff0",
	"./api/config": "da71",
	"./api/config.js": "da71",
	"./api/getRequest": "4e1f",
	"./api/getRequest.js": "4e1f",
	"./api/services/development": "4990",
	"./api/services/development.js": "4990",
	"./api/services/ecommerce": "1a18",
	"./api/services/ecommerce.js": "1a18",
	"./api/services/explainer": "3b8b",
	"./api/services/explainer.js": "3b8b",
	"./api/services/mobileapp": "242c",
	"./api/services/mobileapp.js": "242c",
	"./components/app/ImageApp": "0792",
	"./components/app/ImageApp.vue": "0792",
	"./components/app/Skeleton": "57f1",
	"./components/app/Skeleton.vue": "57f1",
	"./components/blog/BlogContentBuilder": "f7bf",
	"./components/blog/BlogContentBuilder.vue": "f7bf",
	"./components/blog/BlogDetailSkeletion": "4b3f",
	"./components/blog/BlogDetailSkeletion.vue": "4b3f",
	"./components/blog/BlogListSkeleton": "55c9",
	"./components/blog/BlogListSkeleton.vue": "55c9",
	"./components/blog/Current": "1810",
	"./components/blog/Current.vue": "1810",
	"./components/blog/CurrentSkeleton": "5ca4",
	"./components/blog/CurrentSkeleton.vue": "5ca4",
	"./components/blog/DefaultList": "6d9c",
	"./components/blog/DefaultList.vue": "6d9c",
	"./components/blog/MissedList": "93f4",
	"./components/blog/MissedList.vue": "93f4",
	"./components/footer/Copyrights": "1574",
	"./components/footer/Copyrights.vue": "1574",
	"./components/footer/Footer": "4c03",
	"./components/footer/Footer.vue": "4c03",
	"./components/footer/FooterNav": "a14d",
	"./components/footer/FooterNav.vue": "a14d",
	"./components/footer/FooterServices": "3bfb",
	"./components/footer/FooterServices.vue": "3bfb",
	"./components/footer/FooterServicesIntro": "c152",
	"./components/footer/FooterServicesIntro.vue": "c152",
	"./components/footer/NewsLetter": "b3e2",
	"./components/footer/NewsLetter.vue": "b3e2",
	"./components/homepage/Hero": "4ca3",
	"./components/homepage/Hero.vue": "4ca3",
	"./components/homepage/Technology": "7556",
	"./components/homepage/Technology.vue": "7556",
	"./components/homepage/Testimonials": "8b7f",
	"./components/homepage/Testimonials.vue": "8b7f",
	"./components/modal/Fullscreen": "3dfa",
	"./components/modal/Fullscreen.vue": "3dfa",
	"./components/modal/PortfolioModal": "3c98",
	"./components/modal/PortfolioModal.vue": "3c98",
	"./components/modal/ResponsiveMenu": "7f8d",
	"./components/modal/ResponsiveMenu.vue": "7f8d",
	"./components/modal/StartProject": "9495",
	"./components/modal/StartProject.vue": "9495",
	"./components/navigation/AboutHover": "fb30",
	"./components/navigation/AboutHover.vue": "fb30",
	"./components/navigation/Logo": "d706",
	"./components/navigation/Logo.vue": "d706",
	"./components/navigation/MainNav": "c1dc",
	"./components/navigation/MainNav.vue": "c1dc",
	"./components/navigation/ServicesHover": "7a8a",
	"./components/navigation/ServicesHover.vue": "7a8a",
	"./components/navigation/WorksHover": "6b83",
	"./components/navigation/WorksHover.vue": "6b83",
	"./components/policy/Crumb": "8817",
	"./components/policy/Crumb.vue": "8817",
	"./components/policy/Links": "6990",
	"./components/policy/Links.vue": "6990",
	"./components/portfolio/BreadCrumb": "d1bb",
	"./components/portfolio/BreadCrumb.vue": "d1bb",
	"./components/portfolio/MoreProjects": "bdfc",
	"./components/portfolio/MoreProjects.vue": "bdfc",
	"./components/reusable/CompanyCount": "1708",
	"./components/reusable/CompanyCount.vue": "1708",
	"./components/reusable/IllustrationHero": "4232",
	"./components/reusable/IllustrationHero.vue": "4232",
	"./components/reusable/InternalHero": "cfda",
	"./components/reusable/InternalHero.vue": "cfda",
	"./components/reusable/PageFeatures": "279b",
	"./components/reusable/PageFeatures.vue": "279b",
	"./components/reusable/ServicesFaQs": "e566",
	"./components/reusable/ServicesFaQs.vue": "e566",
	"./components/reusable/ServicesHero": "bb3b",
	"./components/reusable/ServicesHero.vue": "bb3b",
	"./components/reusable/ServicesPortfolio": "3462",
	"./components/reusable/ServicesPortfolio.vue": "3462",
	"./components/reusable/ServicesReview": "b6dd",
	"./components/reusable/ServicesReview.vue": "b6dd",
	"./components/reusable/VideoBanner": "5a9e",
	"./components/reusable/VideoBanner.vue": "5a9e",
	"./components/reusable/WhyAStrick": "e576",
	"./components/reusable/WhyAStrick.vue": "e576",
	"./components/web-design/DiscoverArea": "11af",
	"./components/web-design/DiscoverArea.vue": "11af",
	"./css/about.min.css": "148d",
	"./css/astrick.min.css": "c738",
	"./css/blog.min.css": "67d5",
	"./css/navbar.min.css": "f5a8",
	"./css/portfolio.min.css": "54d9",
	"./css/responsive.min.css": "3f43",
	"./fonts/AvertaStd-Regular.ttf": "662c",
	"./fonts/AvertaStd-Thin.ttf": "bc40",
	"./images/api/clients/client-3.png": "2989",
	"./images/api/clients/client-4.png": "f23b",
	"./images/api/clients/client-5.png": "f1de",
	"./images/api/clients/client-6.png": "b696",
	"./images/api/clients/client-7.png": "819a",
	"./images/api/clients/client-8.png": "bc42",
	"./images/api/icons/american-express.png": "10d6",
	"./images/api/icons/esewa.png": "5b0d",
	"./images/api/icons/facebook.png": "5b75",
	"./images/api/icons/khalti.png": "2f3f",
	"./images/api/icons/linkedin.png": "44b9",
	"./images/api/icons/masetro.png": "c51d",
	"./images/api/icons/mastercard.png": "4628",
	"./images/api/icons/paypal.png": "4e3f",
	"./images/api/icons/twitter.png": "1e00",
	"./images/api/icons/visa.png": "b466",
	"./images/api/icons/youtube.png": "27d3",
	"./images/api/large/footer.jpg": "0027",
	"./images/api/large/home-page.jpg": "f676",
	"./images/brand/astrick-logo.svg": "b336",
	"./images/client/5stars-forex.png": "c407",
	"./images/client/allergy-free-air.png": "a212",
	"./images/client/choose-your-forex.png": "0242",
	"./images/client/cloudfiles.png": "0b49",
	"./images/client/hatudo.png": "a45e",
	"./images/client/prestado-logo.png": "a54d",
	"./images/client/scroller-media.png": "5cab",
	"./images/client/shipma.png": "81e6",
	"./images/client/tigerflo.png": "156b",
	"./images/client/user-1.jpg": "87d1",
	"./images/client/user-2.jpg": "2f68",
	"./images/client/user-3.jpg": "7304",
	"./images/client/user-4.jpg": "28c0",
	"./images/client/user-5.jpg": "c0ba",
	"./images/client/user-6.jpg": "f70b",
	"./images/gif/btn-loader.gif": "6561",
	"./images/icons/address.png": "79d5",
	"./images/icons/arrow-right.svg": "3cd9",
	"./images/icons/astrick-logo.svg": "4d63",
	"./images/icons/close.svg": "5eb3",
	"./images/icons/facebook.png": "c4a1",
	"./images/icons/front-end.png": "1a22",
	"./images/icons/google_seo.png": "1e32",
	"./images/icons/hamburger.svg": "6105",
	"./images/icons/help-desk.png": "5c76",
	"./images/icons/home.svg": "3df1",
	"./images/icons/img-error.svg": "2606",
	"./images/icons/img-loading.svg": "8516",
	"./images/icons/info.svg": "1cfe",
	"./images/icons/linkedin.png": "9fa0",
	"./images/icons/mail.svg": "940e",
	"./images/icons/office-phone.png": "5f2b",
	"./images/icons/pix.png": "5388",
	"./images/icons/right.svg": "de58",
	"./images/icons/share.svg": "0bdd",
	"./images/icons/social-media.png": "fb59",
	"./images/icons/twitter.png": "5a3b",
	"./images/icons/user.svg": "1847",
	"./images/icons/youtube.png": "b8c7",
	"./images/large/black-pattern-bg.png": "77d6",
	"./images/medium/social-media.jpg": "cece",
	"./images/medium/woman-call.jpg": "86df",
	"./images/portfolio/5stars-forex.png": "3fda",
	"./images/portfolio/aas-pass-logo.png": "52fd",
	"./images/portfolio/android.png": "dc16",
	"./images/portfolio/astasks.png": "134e",
	"./images/portfolio/choose-your-forex-logo.png": "b514",
	"./images/portfolio/cloudfiles-logo.png": "3ef2",
	"./images/portfolio/facebook.png": "af94",
	"./images/portfolio/instagram.png": "f6ee",
	"./images/portfolio/linkedin.png": "72eb",
	"./images/portfolio/mailchimp.png": "5255",
	"./images/portfolio/multimedia-typing-guide.jpg": "7f03",
	"./images/portfolio/nritana-edutainment-for-student.jpg": "3d78",
	"./images/portfolio/nritana-encyclopedia-of-nepal.jpg": "ce0f",
	"./images/portfolio/psd.png": "c056",
	"./images/portfolio/table-tennis-game.jpg": "1446",
	"./images/portfolio/thrive_logo.png": "1fc5",
	"./images/portfolio/tigerflo.png": "a132",
	"./images/portfolio/twitter.png": "141c",
	"./images/portfolio/xd.png": "7f8b",
	"./images/portfolio/youtube-play.svg": "8cba",
	"./images/portfolio/youtube.png": "3234",
	"./images/services/404.png": "21b8",
	"./images/services/api.png": "85f8",
	"./images/services/arrow-right-white.png": "8a2a",
	"./images/services/backends.png": "8c54",
	"./images/services/black-pattern-bg.png": "fcb3",
	"./images/services/choose-your-forex.jpg": "d6d7",
	"./images/services/choose.png": "05d1",
	"./images/services/color.png": "eba6",
	"./images/services/compare.png": "f143",
	"./images/services/cross-browser.png": "d784",
	"./images/services/custom-design.png": "b191",
	"./images/services/devices.png": "d2de",
	"./images/services/duration.png": "72b3",
	"./images/services/education.png": "2678",
	"./images/services/effects.png": "cc01",
	"./images/services/email-campaign.png": "d059",
	"./images/services/finance.png": "bb24",
	"./images/services/font.png": "4666",
	"./images/services/food.png": "9e5a",
	"./images/services/htmlcss.png": "86ce",
	"./images/services/lazyloading.png": "819c",
	"./images/services/market.png": "eca7",
	"./images/services/material.png": "ae80",
	"./images/services/medical.png": "819c1",
	"./images/services/menu.png": "86bf",
	"./images/services/parallax.png": "f98f",
	"./images/services/payment.png": "24e3",
	"./images/services/play-icon.png": "4723",
	"./images/services/popup.png": "a771",
	"./images/services/pricing_product_not_included.png": "8186",
	"./images/services/rating.png": "6297",
	"./images/services/responsive.png": "9b3f",
	"./images/services/retina.png": "9d0a",
	"./images/services/seo.png": "e5ed",
	"./images/services/services.png": "dc6a",
	"./images/services/setup.png": "583a",
	"./images/services/support.png": "72d1",
	"./images/services/uiux.png": "b726",
	"./images/services/vector.png": "0eb2",
	"./images/services/video-play-icon.png": "6d94",
	"./images/services/video-process.png": "d476",
	"./images/services/w3c.png": "cdc8",
	"./images/skeleton/home-page.jpg": "63b6",
	"./images/svg/about-outline.svg": "7113",
	"./images/svg/about.svg": "64f2",
	"./images/svg/analysis.svg": "ecc9",
	"./images/svg/career.svg": "3e7a",
	"./images/svg/contact.svg": "1fae",
	"./images/svg/delivery.svg": "3db4",
	"./images/svg/development.svg": "dd85",
	"./images/svg/e-commerce.svg": "7679",
	"./images/svg/mobile.svg": "4e3c",
	"./images/svg/planning.svg": "9917",
	"./images/svg/portfolio.svg": "896e",
	"./images/svg/process.svg": "d8de",
	"./images/svg/qa-engineering.svg": "75d9",
	"./images/svg/resp-about.svg": "635d",
	"./images/svg/resp-blog.svg": "22f6",
	"./images/svg/resp-career.svg": "093d",
	"./images/svg/resp-contact.svg": "82a3",
	"./images/svg/resp-ecommerce.svg": "e2ea",
	"./images/svg/resp-explainer.svg": "b2f6",
	"./images/svg/resp-mobile.svg": "08da",
	"./images/svg/resp-portfolio.svg": "9640",
	"./images/svg/resp-team.svg": "b43e",
	"./images/svg/resp-web.svg": "9d08",
	"./images/svg/team.svg": "ecc4",
	"./images/svg/video.svg": "b47a",
	"./images/svg/web.svg": "99f1",
	"./images/team/arjun-kandel.jpg": "def3",
	"./images/team/deepak-sigdel.jpg": "bbb3",
	"./images/team/dhruba-kandel.jpg": "568f",
	"./images/team/mike-subedi.jpg": "d231",
	"./images/team/raju-gaire.jpg": "4637",
	"./images/team/shobha-kandel.jpg": "bcb8",
	"./images/team/surya-kandel.jpg": "521f",
	"./images/technology/adobe-ae.svg": "f873",
	"./images/technology/adobe-xd.svg": "c4c7",
	"./images/technology/android.svg": "e0c8",
	"./images/technology/bootstrap.svg": "d19f",
	"./images/technology/electron.svg": "e237",
	"./images/technology/expo-cli.svg": "cafa",
	"./images/technology/firebase.svg": "e454",
	"./images/technology/google-cloud.svg": "76bb",
	"./images/technology/ios.svg": "e648",
	"./images/technology/javascript.svg": "667b",
	"./images/technology/laravel.svg": "191a",
	"./images/technology/mongo-db.svg": "1619",
	"./images/technology/mysql.svg": "6006",
	"./images/technology/nodejs.svg": "f95b",
	"./images/technology/php.svg": "17c4",
	"./images/technology/pinia.svg": "7c81",
	"./images/technology/react-native.svg": "bab0",
	"./images/technology/vue-nuxt.svg": "c00f",
	"./images/technology/vue.svg": "c1bd",
	"./images/technology/websocket.svg": "dcde",
	"./images/technology/wordpress.svg": "b0c5",
	"./main": "56d7",
	"./main.js": "56d7",
	"./plugins/animate/animate.css": "e5c9",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./views/HomePage": "f4a9",
	"./views/HomePage.vue": "f4a9",
	"./views/Portfolio": "c9e5",
	"./views/Portfolio.vue": "c9e5",
	"./views/about/AboutUs": "ad9d",
	"./views/about/AboutUs.vue": "ad9d",
	"./views/about/Career": "bee2",
	"./views/about/Career.vue": "bee2",
	"./views/about/ContactUs": "d226",
	"./views/about/ContactUs.vue": "d226",
	"./views/about/Cookies": "9b84",
	"./views/about/Cookies.vue": "9b84",
	"./views/about/MeetTheTeam": "e85e",
	"./views/about/MeetTheTeam.vue": "e85e",
	"./views/about/Privacy": "9dfc",
	"./views/about/Privacy.vue": "9dfc",
	"./views/about/Refund": "109e",
	"./views/about/Refund.vue": "109e",
	"./views/about/Terms": "fd2b",
	"./views/about/Terms.vue": "fd2b",
	"./views/about/WorkingProcess": "db51",
	"./views/about/WorkingProcess.vue": "db51",
	"./views/blog/BlogDetail": "4001",
	"./views/blog/BlogDetail.vue": "4001",
	"./views/blog/BlogIndex": "0933",
	"./views/blog/BlogIndex.vue": "0933",
	"./views/portfolio/5StarsForex": "f39d",
	"./views/portfolio/5StarsForex.vue": "f39d",
	"./views/portfolio/AStasks": "85db",
	"./views/portfolio/AStasks.vue": "85db",
	"./views/portfolio/AasPaas": "70cc",
	"./views/portfolio/AasPaas.vue": "70cc",
	"./views/portfolio/ChooseYourForex": "e362",
	"./views/portfolio/ChooseYourForex.vue": "e362",
	"./views/portfolio/CloudFiles": "e452",
	"./views/portfolio/CloudFiles.vue": "e452",
	"./views/portfolio/Encyclopedia": "8ea5",
	"./views/portfolio/Encyclopedia.vue": "8ea5",
	"./views/portfolio/ThriveSocial": "930b",
	"./views/portfolio/ThriveSocial.vue": "930b",
	"./views/portfolio/Tigerflo": "a8bc",
	"./views/portfolio/Tigerflo.vue": "a8bc",
	"./views/portfolio/TypingGuide": "f88e",
	"./views/portfolio/TypingGuide.vue": "f88e",
	"./views/services/Development": "f051",
	"./views/services/Development.vue": "f051",
	"./views/services/Ecommerce": "e0b4",
	"./views/services/Ecommerce.vue": "e0b4",
	"./views/services/ExplainerVideo": "658a",
	"./views/services/ExplainerVideo.vue": "658a",
	"./views/services/MobileApp": "f882",
	"./views/services/MobileApp.vue": "f882"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";